import React from 'react'
import PropTypes from 'prop-types'
import { Overlay, Popover } from 'react-bootstrap'

export default class StickyTrigger extends React.Component {
    constructor(props) {
        super(props)

        this.handleMouseEnter = this.handleMouseEnter.bind(this)
        this.handleMouseLeave = this.handleMouseLeave.bind(this)

        this.state = {
            showPopover: false,
        }
    }

    handleMouseEnter() {
        const { delay, onMouseEnter } = this.props

        this.setTimeoutConst = setTimeout(() => {
            this.setState({ showPopover: true }, () => {
                if (onMouseEnter) {
                    onMouseEnter()
                }
            })
        }, delay);
    }

    handleMouseLeave() {
        clearTimeout(this.setTimeoutConst)
        this.setState({ showPopover: false })
    }

    componentWillUnmount() {
        if (this.setTimeoutConst) {
            clearTimeout(this.setTimeoutConst)
        }
    }

    render() {
        let { component, children, placement, title } = this.props

        const child = React.Children.map(children, (ch) => (
            React.cloneElement(ch, {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                ref: (node) => {
                    this._child = node
                    const { ref } = ch
                    if (typeof ref === 'function') {
                        ref(node);
                    }
                }
            })
        ))[0]

        return(
            <React.Fragment>
            {child}
            <Overlay
            show={this.state.showPopover}
            placement={placement}
            target={this._child}
            shouldUpdatePosition={true}
            >
            <Popover
            title={title}
            onMouseEnter={() => {
                this.setState({ showPopover: true })
            }}
            onMouseLeave={this.handleMouseLeave}
            id='popover'
            >
            {component}
            </Popover>
            </Overlay>
            </React.Fragment>
        )
    }
}

StickyTrigger.defaultProps = {
    delay: 0
}

StickyTrigger.propTypes = {
    delay: PropTypes.number,
    onMouseEnter: PropTypes.func,
    children: PropTypes.element.isRequired,
    component: PropTypes.node.isRequired
}



// WEBPACK FOOTER //
// ./src/fw/components/stickyTrigger/StickyTrigger.js